const businessEvents = require('client/lib/business-events')
const { send: ajax } = require('client/lib/request')
const { alert, confirm } = require('client/components/confirm')

function actionsButtons() {
  return [
    { label: 'Report this user', value: 'report' },
    { label: 'Cancel', value: '' }
  ]
}

async function reportUser({ reportedUser, reporterUser, pageContext }) {
  await ajax({
    url: '/api/v0.1/reports/user',
    method: 'post',
    data: {
      context: 'flag',
      'reported_id': reportedUser.id,
      'page_context': pageContext
    }
  })
  await businessEvents.trackSegment('report-user', {
    'reported_id': reportedUser.id,
    'reporter_id': reporterUser.id
  }, {
    pageContext
  })
  alert({
    heading: 'User Reported',
    subheading: 'Got it - thanks for letting us know!'
  })
}

async function confirmUserAction(options) {
  switch (await confirm({
    heading: 'Actions for this User',
    buttons: actionsButtons(),
    closeOnBackdropClick: true
  })) {
    case 'report':
      return reportUser(options)
  }
}

module.exports = {
  confirmUserAction,
  reportUser
}
